import { createFileRoute, Outlet } from "@tanstack/react-router";
import { StaffShell } from "@/components/staff-shell";
import { useRoleGuard } from "@/hooks/use-role-guard";

export const Route = createFileRoute("/tasks")({
  head: () => ({
    meta: [
      { title: "Tasks - DeckScore" },
      { name: "robots", content: "noindex" },
    ],
  }),
  component: TasksLayout,
});

function TasksLayout() {
  const { status } = useRoleGuard(["admin", "super_admin"]);
  if (status !== "ok") {
    return (
      <div className="min-h-screen bg-bg grid place-items-center text-ink-secondary">
        Loading…
      </div>
    );
  }
  // Use the task-focused StaffShell for both admin and super_admin so the
  // /tasks queue always shows the same nav (My Tasks · Analytics), without
  // the near-duplicate Analyses/Analytics pair from the full admin sidebar.
  return (
    <StaffShell>
      <Outlet />
    </StaffShell>
  );
}

